import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_GROUP_POSTS_ERROR, DELETE_GROUP_POSTS_START, DELETE_GROUP_POSTS_SUCCESS} from "../../types";

export function* deleteGPosts({payload}) {
    try {
        const url = `/group_posts/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_GROUP_POSTS_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-post'))
    } catch (error) {
        yield put({type: DELETE_GROUP_POSTS_ERROR, error});
    }
}

export default function* delete_group_posts() {
    yield takeLatest(DELETE_GROUP_POSTS_START, deleteGPosts);
}